import { render, staticRenderFns } from "./12zhihuijiaoyu.vue?vue&type=template&id=2f5a8a8c&scoped=true&"
import script from "./12zhihuijiaoyu.vue?vue&type=script&lang=js&"
export * from "./12zhihuijiaoyu.vue?vue&type=script&lang=js&"
import style0 from "./12zhihuijiaoyu.vue?vue&type=style&index=0&id=2f5a8a8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a8a8c",
  null
  
)

export default component.exports